<nav class="navbar">
  <div class="container level">
    <div class="level-item">
      <div class="flex flex-start">
        <h1 class="is-size-3 has-text-weight-semibold">IdP Data Aggregation</h1>
      </div>

      <div class="flex flex-end flex-items-center flex-align-center">
        <span class="title is-6" style="margin-right: 10px">
          {{ user?.name }}
          <span class="title is-7">
            {{ getUserDescription() }}
          </span>
        </span>
        <logout></logout>
      </div>
    </div>
  </div>
</nav>
